import Swiper from 'swiper';

export default function carousel() {

    $('.swiper-container:not(".gallery-img, .partners-carousel, .csr-carousel, .extra-content-carousel, .article-carousel, .latest-in-blog-carousel, .gallery-thumbs, .vehicle-image, .vehicle-thumbs, [data-slider-testimonials], [data-widget-homeslider-slider]")').each(function(index, element) {

        let $this = $(this),
            $carousel = $this.parents('.carousel-wrap').find('.swiper-slide');

        $this.addClass('instance-' + index);
        $this.parents('.carousel-wrap').find('.swiper-next-btn').addClass('swiper-next-btn-' + index);
        $this.parents('.carousel-wrap').find('.swiper-prev-btn').addClass('swiper-prev-btn-' + index);

        let mySwiper = new Swiper('.instance-' + index, {
            speed: 500,
            spaceBetween: 30,
            slidesPerView: 4,
            observer: true,
            navigation: {
                nextEl: '.swiper-next-btn-' + index,
                prevEl: '.swiper-prev-btn-' + index
            },
            breakpoints: {
                1199: {
                    slidesPerView: 3,
                },
                1023: {
                    slidesPerView: 'auto',
                },
                767: {
                    slidesPerView: 'auto',
                    slidesOffsetAfter: 45,
                    slidesOffsetBefore: 45,
                },
                599: {
                    slidesPerView: 'auto',
                    slidesOffsetAfter: 20,
                    slidesOffsetBefore: 20,
                },
            }
        });

        if ($carousel.length <= 4 && window.innerWidth >= 1023) {
            mySwiper.destroy();
            $this.parents('.carousel-wrap').addClass('carousel-wrap--destroyed');
        }
        if (window.innerWidth <= 1023) {
            $this.parents('.carousel-wrap').removeClass('carousel-wrap--destroyed');
            mySwiper.init();
        }

        $(window).resize(function() {
            mySwiper.init();
        });

    });
}